import MaisAcessoApsIcon from '@/components/icons/IndicadoresAps/eSFeAP/MaisAcessoAps.vue'

export default {
  value: 'c1',
  label: 'Mais acesso',
  iconType: 'component',
  iconComponent: MaisAcessoApsIcon,
  buscaAtiva: {},
}
